import Message from 'owa-service/lib/contract/Message';
import {
    InfoBarMessageColor,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { infoMessageClassification } from './createMessageClassificationInfoBarMessage.locstring.json';
import getClassificationFromMessage from 'owa-mail-protection/lib/utils/classification/getClassificationFromMessage';
import loc, { format } from 'owa-localize';

export default function createMessageClassificationInfoBarMessage(
    message: Message,
    key: string
): InfoBarMessageViewState {
    const messageClassification = getClassificationFromMessage(message);
    if (!messageClassification) {
        return null;
    }

    const classificationName = messageClassification.Name ? messageClassification.Name : '';

    return <InfoBarMessageViewState>{
        key: key,
        source: InfoBarMessageSource.ReadingPane,
        rank: InfoBarMessageRank.Info,
        color: InfoBarMessageColor.Grey,
        messageParts: [
            format(
                loc(infoMessageClassification),
                classificationName,
                messageClassification.Description
            ),
        ],
    };
}
